import { TLocale } from '@aviv-estimation-funnel/shells/src/app/helpers/i18n';

export const locale =
    process.env.NODE_ENV === 'development'
        ? (new URLSearchParams(window.location.search)?.get('lang') as TLocale) ?? 'en'
        : 'de';
